import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment as env, environment } from '@environments/environment';
import { DriverProfle } from '@app/modules/driver/models/driver.models';
import { forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { DriverDetailsDto, DriverList } from '@app/core/models/zonar-accounts.model';

@Injectable({
  providedIn: 'root'
})
export class DriverApiService {
  v1baseUrl = `${environment.vdofleet.baseApiUrl}/master-data-service/v1/drivers`;

  constructor(private http: HttpClient) {}

  // getDriversByAccount(accountId: string): Observable<DriverDetailsDto[]> {
  //   let params = new HttpParams();
  //   params = params.append('accountId', accountId);
  //   params = params.append('size', 2000);
  //   return this.http.get<DriverList>(this.v1baseUrl, { params: params }).pipe(map(resp => resp.data));
  // }

  getDriversByAccount(accountId: string): Observable<DriverDetailsDto[]> {
    const PAZE_SIZE = 200;
    const paramsBase = new HttpParams().set('accountId', accountId).set('size', PAZE_SIZE).set('sort', 'id,asc');

    return this.http.get<DriverList>(this.v1baseUrl, { params: paramsBase.set('page', 0) }).pipe(
      switchMap(firstResp => {
        const totalPages = firstResp.totalNumberOfPages;
        const allRequests: Observable<DriverList>[] = [];

        for (let page = 1; page < totalPages; page++) {
          const params = paramsBase.set('page', page);
          allRequests.push(this.http.get<DriverList>(this.v1baseUrl, { params }));
        }

        return forkJoin([of(firstResp), ...allRequests]);
      }),
      map(responses => responses.flatMap(resp => resp.data))
    );
  }

  // map vdo drivers to driverProfiles, keep zonar structure for refacto
  // A driver can hold several driver cards over time (e.g. renewals/replacements), so one
  // DriverProfle is created per driver card - using driverCard.cardNumber as the primary id -
  // instead of collapsing them down to only the currently active card. This lets callers match
  // historical data (e.g. past trips) against the driver card that was active at that time.
  getDriverProfilesByAccount(accountId: string): Observable<DriverProfle[]> {
    return this.getDriversByAccount(accountId).pipe(
      map((drivers: DriverDetailsDto[]) => {
        const res = [];
        for (var driver of drivers) {
          // can not match if no driver card
          if (driver.driverCards?.length) {
            for (const driverCard of driver.driverCards) {
              const driverProfile = {
                id: driverCard.cardNumber,
                driverId: '' + driver.id,
                companyId: '' + driver.siteAccountId,
                divisionId: driver.siteId,
                legacyFirstName: driver.firstName,
                legacyLastName: driver.lastName,
                cdl: driverCard.cardNumber,
                cardValidityBegin: driverCard.cardValidityBegin,
                cardExpiryDate: driverCard.cardExpiryDate,
                active: driverCard.active
              };
              res.push(driverProfile);
            }
          }
        }
        return res;
      })
    );
  }

  // getDriversByCardNumbers(cardNumberList: string[]): Observable<DriverDetailsDto[]>{
  //   let params = new HttpParams();
  //   params = params.append('driverIdentification', cardNumberList.join(','));
  //   const url = `${environment.vdofleet.baseApiUrl}/master-data-service/v1/drivers`; // /accountId/${accountId}
  //   return this.http.get<DriverList>(url, { params: params }).pipe(map(resp => resp.data));
  // }

  getDriverByCardNumber(cardNumber: string): Observable<DriverDetailsDto[]> {
    let params = new HttpParams();
    // params = params.append('accountId', accountId);
    params = params.append('driverIdentification', cardNumber);
    return this.http.get<DriverList>(this.v1baseUrl, { params }).pipe(map(resp => resp.data));
  }

  getDriverProfileByCardNumber(cardNumber: string): Observable<DriverProfle> {
    return this.getDriverByCardNumber(cardNumber).pipe(
      map((drivers: DriverDetailsDto[]) => {
        if (drivers?.length) {
          const driver = drivers[0];
          const driverCard = driver.driverCards?.find(item => item.cardNumber === cardNumber);
          return {
            id: cardNumber,
            driverId: '' + driver.id,
            companyId: '' + driver.siteAccountId,
            divisionId: driver.siteId,
            legacyFirstName: driver.firstName,
            legacyLastName: driver.lastName,
            cdl: cardNumber,
            cardValidityBegin: driverCard?.cardValidityBegin,
            cardExpiryDate: driverCard?.cardExpiryDate,
            active: driverCard?.active
          };
        }
        return null;
      })
    );
  }

  // getDriverProfilesByCardNumbers(cardNumberList: string[]): Observable<DriverProfle[]>{
  //   return this.getDriversByCardNumbers(cardNumberList).pipe(
  //     map( (drivers:DriverDetailsDto[]) => {
  //       const res = []
  //       if(drivers?.length){
  //         for(var driver of drivers){
  //           const driverProfile = {
  //             id: driver.cdl,
  //             driverId: ""+driver.id,
  //             companyId: ""+driver.siteAccountId,
  //             divisionId: driver.siteId,
  //             legacyFirstName: driver.firstName,
  //             legacyLastName: driver.lastName,
  //             cdl: driver.driverCards?.length ? driver.driverCards[0].cardNumber : ""
  //           }
  //           res.push(driverProfile)
  //         }
  //       }
  //       return res
  //     })
  //   )
  // }
}
